import * as React from 'react';
import { type JSX } from 'react';
import { dsClass } from '../../common/constants/dsClasses';
import { HorizontalCardPopOver } from './SubscriptionCard';
import type { CLPopoverImperativeRefHandle } from '../../common/types/componentLibrary';

import './SubscriptionModal.scss';

export type SubscriptionCardOfferSpec = {
  name: string;
  value: string;
  popoverContent?: JSX.Element;
};

interface OfferSpecificationsProps {
  specifications?: SubscriptionCardOfferSpec[];
  activePopoverRef: React.MutableRefObject<CLPopoverImperativeRefHandle | null>;
}

export const OfferSpecifications = ({ specifications, activePopoverRef }: OfferSpecificationsProps) => (
  <div className={dsClass.MARGIN_TOP_2}>
    {specifications?.map((specification, i) => (
      <div
        key={`offer-inclusion-row-${i}`}
        className={`of-subscription-card--specification ${dsClass.DISPLAY_FLEX} ${dsClass.JUSTIFY_CONTENT_SPACE_BETWEEN} ${dsClass.MARGIN_TOP_1}`}
        aria-disabled="true"
      >
        <div className={`${dsClass.TEXT_XS} of-subscription-card--specification--start`}>{specification.name}</div>
        <div className="of-subscription-card--specification--word-separator"></div>
        <div className={`${dsClass.TEXT_XS} of-subscription-modal--specification-end`}>
          {specification.value}
          <HorizontalCardPopOver activePopoverRef={activePopoverRef} content={specification.popoverContent} />
        </div>
      </div>
    ))}
  </div>
);
